import { Routes } from '@angular/router';
import { PageNotFoundComponent } from 'projects/vpo-shared/src/public-api';
import {
  ROUTER_IDENTIFIER_LETO,
  ROUTER_IDENTIFIER_JEZIK,
} from 'projects/vpo-shared/src/vpoglednik/vpoglednik.model';
import { VpoglednikComponent } from 'projects/vpo-shared/src/vpoglednik/vpoglednik.component';

export const routes: Routes = [
  {
    path: 'vpoglednik/:' + ROUTER_IDENTIFIER_LETO,
    redirectTo: 'vpoglednik/:' + ROUTER_IDENTIFIER_LETO + '/SI',
    pathMatch: 'full',
  },
  {
    path: 'vpoglednik',
    redirectTo: 'vpoglednik/-1/SI',
    pathMatch: 'full',
  },
  {
    path: 'vpoglednik/:' + ROUTER_IDENTIFIER_LETO + '/:' + ROUTER_IDENTIFIER_JEZIK,
    component: VpoglednikComponent,
  },
  {
    path: '404',
    pathMatch: 'full',
    component: PageNotFoundComponent,
  },
  {
    path: '**',
    redirectTo: '404',
    pathMatch: 'full',
  },
];
